/** * 系统操作日志 */
<template>
	<div>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item class="right">
				<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增
				</el-button>
				<my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
			</el-form-item>
		</el-form>
		<!--列表-->
		<STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading">
			<el-table-column slot="isForce" prop="isForce" label="是否强制更新" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="scope.row.isForce" class="state_true">是</span>
					<span v-else class="state_false">否</span>
				</template>
			</el-table-column>
			<el-table-column slot="isLastest" prop="isLastest" label="是否是最新版" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="scope.row.isLastest" class="state_true">是</span>
					<span v-else class="state_false">否</span>
				</template>
			</el-table-column>
		</STable>
		<!-- 分页组件 -->
		<!-- <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
		<!-- 上传 -->
		<versionUpload ref="versionUpload"></versionUpload>
	</div>

</template>

<script>
import {
	GetSystemUpdateHistoryList
} from '../../../api/systemApi.js';
import versionUpload from './versionUpload.vue'
export default {
	props: {
		type: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				type: 1
			},
			listData: [],
			timeData: [],
			columnsData: [], //显示列
			listColumns: [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '60',
				isKeep: true
			}, {
				prop: 'version',
				label: '版本号',
				isKeep: true
			}, {
				prop: 'fileSize',
				label: '文件大小（B）',
			}, {
				prop: 'description',
				label: '更新说明',
			},
			{
				slot: 'isForce',
				label: '是否强制更新',
			}, {
				slot: 'isLastest',
				label: '是否是最新版',
			}
			],
		};
	},
	// 注册组件
	components: {
		versionUpload
	},
	/**
	 * 创建完毕
	 */
	created() {
		this.formInline.type = this.type
		if (this.type === 1) {
			this.listColumns = [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '60',
				isKeep: true
			}, {
				prop: 'version',
				label: '版本号',
				isKeep: true
			}, {
				prop: 'fileSize',
				label: '文件大小',
			}, {
				prop: 'description',
				label: '更新说明',
			},
			{
				slot: 'isForce',
				label: '是否强制更新',
			}, {
				slot: 'isLastest',
				label: '是否是最新版',
			},
			{
				prop: 'creator',
				label: '上传人',
			},
			{
				prop: 'createTime',
				label: '上传时间',
			},
			{
				prop: 'releaseDate',
				label: '版本更新时间',
				isKeep: true
			},
			]
		} else {
			this.listColumns = [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '60',
				isKeep: true
			}, {
				prop: 'version',
				label: '版本号',
				isKeep: true
			}, {
				prop: 'fileSize',
				label: '文件大小',
			}, {
				prop: 'description',
				label: '更新说明',
			},
			{
				prop: 'creator',
				label: '上传人',
			},
			{
				prop: 'createTime',
				label: '上传时间',
			},
			{
				prop: 'releaseDate',
				label: '版本更新时间',
				isKeep: true
			},
			]
		}
		// 初始列
		this.getCheckBox(this.listColumns.map(item => item.label))
		this.getListData();
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		//显示编辑界面
		handleEdit() {
			this.$refs.versionUpload.editShow(this.formInline.type);
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter(v => !val.includes(v.label))
			this.columnsData = this.listColumns.filter(i => !arr.includes(i));
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.timeData = [];
			this.inputChange();
		},
		// 查询
		inputChange() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

		// 获取列表
		getListData() {
			GetSystemUpdateHistoryList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data.map(item => {
							item.fileSize = this.convertBytesToSize(item.fileSize)
							return item
						});
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: 'info',
							message: '暂无数据',
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error('数据加载失败，请稍后再试！');
				});
		},
		// 文件大小转换
		convertBytesToSize(bytes) {
			const BYTES_IN_KILOBYTES = 1024;
			const BYTES_IN_MEGABYTES = 1048576;
			const BYTES_IN_GIGABYTES = 1073741824;

			if (bytes < BYTES_IN_KILOBYTES) {
				return `${bytes} B`;
			} else if (bytes < BYTES_IN_MEGABYTES) {
				return `${(bytes / BYTES_IN_KILOBYTES).toFixed(2)} KB`;
			} else if (bytes < BYTES_IN_GIGABYTES) {
				return `${(bytes / BYTES_IN_MEGABYTES).toFixed(2)} MB`;
			} else {
				return `${(bytes / BYTES_IN_GIGABYTES).toFixed(2)} GB`;
			}
		},

		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},



	},
};
</script>

<style scoped>
.right {
	display: flex;
	flex-direction: row-reverse
}

.state_true {
	background: #ff0000;
	color: #ffffff;
	padding: 3px 10px;
	border-radius: 3px;
}

.state_false {
	background: #ffaa7f;
	color: #ffffff;
	padding: 3px 10px;
	border-radius: 3px;
}
</style>